import React, { useState, useEffect } from 'react';
import SelectColourButton from './selectColourButton';

export default function ChatEditModule({ eventModuleRow, updateEventModuleRow }) {
    const [chatDisplayName, setChatDisplayName] = useState(eventModuleRow.name);
    const [bStyle, setBStyle] = useState(eventModuleRow.colour);

    useEffect(() => {
        setChatDisplayName(eventModuleRow.name);
        setBStyle(eventModuleRow.colour);
    }, [eventModuleRow]);

    function handleChange(e) {
        const newName = e.target.value;
        setChatDisplayName(newName);
        updateEventModuleRow({
            name: newName,
            colour: bStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    function colourSelected(newStyle) {
        setBStyle(newStyle);
        updateEventModuleRow({
            name: chatDisplayName,
            colour: newStyle,
            event_grouping_seq: eventModuleRow.event_grouping_seq,
            module_type_id: eventModuleRow.module_type_id,
        });
    }

    return (
        <div>
            <input type="text" style={{ width: '50%' }} className="form-control input-md"
                name="chatDisplayName" value={chatDisplayName}
                onChange={handleChange} placeholder="Enter Chat Display Name" />
            <SelectColourButton
                title="Select Colour"
                groupingSequence={eventModuleRow.event_grouping_seq}
                selectedColour={colourSelected}
                bStyle={bStyle} />
        </div>
    );
}
